// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {ProjectTypeModel} from '@supermove/models';

// App
import FieldValue from '@shared/design/components/Field/FieldValue';

const ProjectTypeValuationCoverageBillingPanel = ({
  projectType,
}: {
  projectType: ProjectTypeModel;
}) => {
  return (
    <FieldValue
      label={'Tax Valuation Coverage'}
      value={projectType.features.taxValuationCoverage ? 'Yes' : 'No'}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectTypeValuationCoverageBillingPanel.fragment = gql`
  fragment ProjectTypeValuationCoverageBillingPanel on ProjectType {
    id
    features {
      taxValuationCoverage
    }
  }
`;

export default ProjectTypeValuationCoverageBillingPanel;
